import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-color: transparent;
    box-shadow: none;
    .ant-carousel {
      max-height: calc(100vh - 100px);
      overflow-y: auto;
      overflow-x: hidden;
    }
    .ant-modal-close {
      top: 0;
      right: -15px;
      width: 32px;
      height: 32px;
    }
  }
  .ant-modal-footer {
    margin: 0;
  }
`;

export const StyledModalContent = styled.div`
  background-color: #ffffff;
  padding: 48px 32px;
  min-height: calc(100vh - 100px);
  min-width: 550px;
  height: calc(100vh - 200px);
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
`;

export const StyledTitle = styled.span`
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #0b1a30;
  width: 100%;
  display: inline-block;
`;

export const AvatarContainer = styled.div`
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  img {
    width: 76px !important;
    height: 76px !important;
    border-radius: 8px;
    object-fit: cover;
  }
  span {
    padding: 20px 0 16px;
    color: #0b1a30;
    line-height: 20px;
  }
`;

export const SignatureContainer = styled.div`
  padding: 0 24px;
  width: 148px;
  border-bottom: 1px solid #dbdde2;
  margin-bottom: 4px;
`;
